import type { ReactNode } from "react"

export type DefRow = {
  label: ReactNode
  value: ReactNode
  /** 한 줄을 다 쓴다(비고처럼 긴 값). */
  wide?: boolean
}

/**
 * 라벨–값 목록. 넓으면 2열, 좁으면 1열.
 *
 * 라벨을 값 위에 얹는다 — 라벨과 값을 좌우로 두면 긴 라벨이 값 칸을 찌그러뜨린다.
 */
export function DefinitionList({ rows, columns = 2 }: { rows: DefRow[]; columns?: 1 | 2 }) {
  return (
    <dl className={`defs defs--${columns}`}>
      {rows.map((row, index) => (
        <div key={index} className={row.wide ? "defs__item defs__item--wide" : "defs__item"}>
          <dt className="defs__label">{row.label}</dt>
          <dd className="defs__value">{row.value}</dd>
        </div>
      ))}
    </dl>
  )
}
